<template>
    <div>
        <div v-for="(option, i) in options" :key="i" >
            <b-row align-h="center">
                <b-col cols="12" sm="10" md="8" lg="6">
                    <div class="multi-buttons__input-button mb-2">
                        <input-button
                            :active="option.value === activeButton"
                            @click="handleSelect(option)"
                        >
                            <span v-html="option.text"></span>
                        </input-button>
                    </div>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
import inputButton from '@/components/inputs/button'

export default {
    name: 'multiButtons',
    components: {
        'input-button': inputButton
    },
    props: {
        options: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            activeButton: null
        }
    },
    methods: {
        handleSelect(option) {
            this.activeButton = option.value
            this.$emit('select', option)
        }
    }
}
</script>